import {useEffect, useState} from "preact/hooks";
import {useDispatch, useSelector} from "react-redux";
import {
    fetchInformativeSession,
    fetchInformativeSessions,
    fetchPastSessions,
    getSessionURL
} from "../../../_rx/informative-sessions/actions";
import {AppPage} from "../../../_common/components/app-page";
import {useHistory} from "react-router";
import {F} from "../../../_common/layout";
import {t} from "../../../_i18n";
import {h} from "preact";
import {Link} from "react-router-dom";
import './informative-sessions-style.scss';
import {isMobileAgent} from "../../../_common/common";
import {toastService} from "../../../_services/toast-service";
import {LANG_ES, LANG_FR, LANG_IT} from "../../../constants";
import getLangByShopId from "../../../_common/utils/getLang";
import AlertBox from "../../../_common/components/AlertBox/AlertBox";


export const InformativeSessions = (props) => {
    const dispatch = useDispatch();
    const { informativeSessions, student_meta } = useSelector(state => ({
        informativeSessions: state.informativeSessionReducer.informativeSessions,
        student_meta: state.status.student_meta
    }));
    const pastInformativeSessions = useSelector(state => state.informativeSessionReducer.pastSessions);
    const history = useHistory();
    const isMobile = isMobileAgent();
    const [loading, setLoading] = useState(true);

    const loadPastAndFutureInformativeSession = async () => {
        try {
            setLoading(true);
            await dispatch(fetchInformativeSessions());
            await dispatch(fetchPastSessions());
        } catch (error) {
            console.log(error)
            toastService.showToast({ message:t("Error al cargar las sesiones informativas."), type:'danger' });
        } finally {
            setLoading(false);
        }
    }

    useEffect(async () => {
        await loadPastAndFutureInformativeSession();
    }, []);

    const handleClick = async (uuid) => {
        try {
            await dispatch(getSessionURL(uuid));
            const sessionURL = useSelector(state => state.informativeSessionReducer.sessionURL.url);
            if (sessionURL) {
                window.open(sessionURL, '_blank');
            } else {
                throw new Error('URL no disponible');
            }
        } catch (error) {
            toastService.showToast({ message:t("Error al obtener la URL de la sesión."), type:'danger' });
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const options = { day: 'numeric', month: 'long' };
        const langMapping = { [LANG_ES]: 'es-ES', [LANG_IT]: 'it-IT', [LANG_FR]: 'fr-FR' };
        const lang = getLangByShopId(student_meta.shop_id);
        const locale = langMapping[lang] || 'es-ES';
        const formattedDate = date.toLocaleDateString(locale, options);
        const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
        const formattedTime = date.toLocaleTimeString(locale, timeOptions);
        return `${formattedDate} ${t('formato fecha')} ${formattedTime}`;
    };

    return <AppPage
        name={t('Sesiones informativas')}
        back={history.back}
        class="max-width-980">
        <F className="max-width-980 informative-sessions">
            {!loading && (!informativeSessions?.length && !pastInformativeSessions?.length) && (
                <AlertBox type="warning">
                    <div dangerouslySetInnerHTML={{__html: t('No hay sesiones informativas disponibles en este momento.')}}></div>
                </AlertBox>
            )}
            { loading ? (
                <div></div>
            ) : (informativeSessions && informativeSessions.length > 0 &&
                <div className="m-l m-r">
                    <div className="back breadcrumb-item cursor-pointer"
                         onClick={() => history.goBack()}>
                        <i className="far fa-arrow-left p-left-half no-margin-left m-r-half"
                           aria-hidden="true"></i> {t('Volver')}
                    </div>
                    <h1 className='hero m-top m-bottom'>{t('Sesiones informativas')}</h1>
                    <div className='card p-all sm-p-x2-left sm-p-x2-right sm-p-x2-bottom'>
                        <h1 className={`${!isMobile ? '' : 'font-size-mobile'} bold m-bottom`}>{t('Próximas sesiones')}</h1>
                        {informativeSessions.map((session, index) => (
                            <div key={session.uuid} className='card-dashboard-session__content'>
                                <span className="grey"> {formatDate(session.start_at)} </span>
                                <p className={`${!isMobile ? 'type-sesion' : 'type-sesion-mobile'} bold`}>
                                    {session.name}
                                    {!!session.is_running &&
                                        <div class="without-text-decoration container-tag" onClick={() => handleClick(session.uuid)}>
                                            <p class="tag">
                                                <i className="fas fa-play-circle" aria-hidden="true"></i>
                                                <span className="direct">{t('En directo')}</span>
                                            </p>
                                        </div>
                                    }
                                </p>
                                <div className="url">
                                    <Link to={`/informative-session/${session.uuid}`}
                                          class="without-text-decoration">
                                        {t('Ver detalles')}
                                        <i className="far fa-arrow-right p-left-half" aria-hidden="true"></i>
                                    </Link>
                                </div>
                                {index !== informativeSessions.length - 1 &&
                                    <hr className="separator-xs"/>
                                }
                            </div>
                        ))}
                    </div>
                </div>
            )}
            { loading ? (
                <div></div>
            ) : (pastInformativeSessions && pastInformativeSessions.length > 0 &&
                <div className="m-l m-r">
                    <div className={`${!isMobile ? 'sm-p-x2-left sm-p-x2-right sm-p-x2-bottom' : 'card-session-mobile'} card p-all m-top-x2`}>
                        <h1 className={`${!isMobile ? '' : 'font-size-mobile'} bold m-bottom`}>{t('Grabaciones de sesiones pasadas')}</h1>
                        {pastInformativeSessions.map((pastSession, index) => (
                            <div key={pastSession.uuid} className='card-dashboard-session__content'>
                                <span className="grey"> {formatDate(pastSession.start_at)} </span>
                                <p className={`${!isMobile ? 'type-sesion' : 'type-sesion-mobile'} bold`}>
                                    {pastSession.name}
                                </p>
                                <div className="url">
                                    <Link to={`/informative-session/${pastSession.uuid}`}
                                          class="without-text-decoration">
                                        {t('Ver detalles')}
                                        <i className="far fa-arrow-right p-left-half" aria-hidden="true"></i>
                                    </Link>
                                </div>
                                {index !== pastInformativeSessions.length - 1 &&
                                    <hr className="separator-xs" />
                                }
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </F>
    </AppPage>

}
